import { render, staticRenderFns } from "./NewEventDescription.vue?vue&type=template&id=aac4208e&"
import script from "./NewEventDescription.vue?vue&type=script&lang=js&"
export * from "./NewEventDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports